import React, { useEffect } from 'react';
import { X, Mail, Building2, Clock, Shield } from 'lucide-react';

const ContactModal = ({ isOpen, onClose }) => {
  // Chiudi con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        <button className="contact-modal-close" onClick={onClose} aria-label="Chiudi">
          <X size={24} />
        </button>
        
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">
            <span className="gradient-text">Parliamo</span> del tuo progetto
          </h2>
          <p className="contact-modal-subtitle">
            Il nostro team di esperti è pronto ad ascoltare le tue esigenze
          </p>
        </div>

        <div className="contact-modal-content">
          <div className="contact-modal-features">
            <div className="contact-feature">
              <Clock size={20} />
              <span>Risposta rapida</span>
            </div>
            <div className="contact-feature">
              <Shield size={20} />
              <span>Consulenza gratuita</span>
            </div>
            <div className="contact-feature">
              <Building2 size={20} />
              <span>Soluzioni enterprise</span>
            </div>
          </div>

          <div className="contact-modal-cta">
            <p className="contact-modal-text">
              Descrivi le tue necessità IT e ricevi una proposta personalizzata 
              per la sicurezza e la gestione della tua infrastruttura aziendale.
            </p>
            
            <a 
              href="mailto:info@edp.srl?subject=Richiesta%20informazioni%20-%20Servizi%20IT" 
              className="contact-modal-button"
            >
              <Mail size={20} />
              <span>Scrivici a info@edp.srl</span>
            </a>
            

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
